import React, { useEffect, useState } from "react";
import "../../../StyleSheet/AppComponent/Navbar/Navbar.scss";
import logo from "../../../Assets/AppComponent/Logo/Group 56.png";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import $ from "jquery";
import profile from "../../../Assets/AppComponent/Profile/Profile1.webp";
import { useDispatch, useSelector } from "react-redux";
import {
  getsidebarActions,
  getSideBarfilesActions,
  SetActiveTabs ,
} from "../../../Redux/Slice";
import ReorderOutlinedIcon from "@material-ui/icons/ReorderOutlined";
import Logo1 from "../../../Assets/AppComponent/Logo/Group 85.png";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { useNavigate } from "react-router-dom";
import logoimg from "../../../Assets/logoimg.png";

import Loginlogo from "../../../Assets/AppComponent/Group 180.svg";



const Navbar = () => {
  const dispatch = useDispatch();
  let [isActive, setActive] = useState("false");
  const [LogoOut, setLogoOut] = useState(false);
  const stateToogle = useSelector((state) => state.SideBarActive.SidebarActive);
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const [zooomscreen, setzoomScreen] = useState(window.devicePixelRatio);
  const HandleSideToggle = () => {
    setActive(!isActive);
    dispatch(getsidebarActions(isActive));
    // console.log(stateToogle, "dsafa");
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const UserData = useSelector((state) => state.users.UserData.data);
  const RoleBased = useSelector((state) => state.SideBarFiles.NameRoles);
 const [Images , setImages] = useState()

  useEffect(() => {
    if (state.users.UserData.data != undefined) {

      if (UserData.user_image) {
        console.log(UserData.user_image , "238743209UserData");
        setImages(UserData.user_image.media_url)
      }
    }


  }, [UserData]);

  //   const screenWidth = window.innerWidth;
  // const screenHeight = window.innerHeight;

  // const totalScreenWidth = window.screen.width;
  // const totalScreenHeight = window.screen.height;

  // const screenWidthPercentage = (screenWidth / totalScreenWidth) * 100;
  // const screenHeightPercentage = (screenHeight / totalScreenHeight) * 100;

  // console.log(`Screen width: ${screenWidthPercentage}% of total screen width`);
  // console.log(`Screen height: ${screenHeightPercentage}% of total screen height`);

  // console.log(zooomscreen, "zooomscreen");
  
  // useEffect(() => {
  //   if (zooomscreen >= 1.25) {
  //     setActive(isActive);
  //     dispatch(getsidebarActions(isActive));
  //   }
  // }, [zooomscreen]);

  const HandleClick = () => {
    $(".dropdown-menu").toggle();
    setLogoOut(!LogoOut);
  };
  $(".App").on("click", function () {
    $(".dropdown-menu").hide();
  });

  const handleLOgout = () => {
    window.location.reload();
    localStorage.clear();
    window.location.href = "/";
  };


  return (
    <>
      <div class="header">
        <div className={stateToogle ? "HeaderPart" : "header-left"}>
          <a
            onClick={(e) => {
              // dispatch(getSideBarfilesActions("DashBoard"));
              // navigate("/");
            }}
            class="logo NormalLogo"
          >
            <img src={Loginlogo} alt="Logo"/>
          </a>
          <a
            onClick={(e) => {
            }}
            class=" logo-small"
          >
            <img src={Loginlogo} alt="Logo" width="40" height="70" />

          </a>
        </div>
        <div
          className={` NavbarClicks ${stateToogle ? "toggelTes" : "toggle"}`}
          onClick={HandleSideToggle}
        >
          <a
            href="javascript:void(0);"
            className={` ICONS ${stateToogle ? "closetoggle" : "toggle_btn"}`}
          >
            <MenuRoundedIcon
              style={{
                width: "40px",
                height: "30px",
                cursor: "pointer",
              }}
            />

            {/* <i class="fa-solid fa-bars toggleBtns" ></i> */}
          </a>
        </div>
        <ul class="nav user-menu">
          <div className="NavMenuSet">
            <div className="NavMenus">
              <div className="User-Menu">
                <div className="Profile-Name">
                  <div
                    className="AdminImg"
                    onClick={(e) => {
                      HandleClick();
                    }}
                     style={{border:"1px solid #ddd"}}
                  >
                    <img 
                    src={
                      Images != null && Images != undefined && Images != ""?
                      Images
                      :
                      
                      profile2} 
                    />
                  </div>
                  {/* <span>{UserData.first_name}</span> */}
                </div>

                <div className={`dropdown-menu `}>
                  <div class="user-header">
                    <div
                      class="avatar avatar-sm"
                      // style={{ width: "70px", height: "70px" }}
                       style={{width:"77px", height:"67px", border:"1px solid #ddd", borderRadius:"50%"}}
                    >
                      <img
                        src={
                          Images != null && Images != undefined && Images != ""?
                      Images
                      :
                      
                      profile2
                        }
                        alt="User Image"
                        class="avatar-img rounded-circle"
                        style={{ width: "100%", dropdownheight: "100%"  , height:"100%"}}
                      />
                    </div>
                    <div class="user-text">
                      <div className="row">
                        <div className="col-md-6" style={{ textAlign: "end" }}>
                          <h6>User :</h6>
                        </div>
                        <div
                          className="col-md-6"
                          style={{ textAlign: "center" }}
                        >
                          {UserData != undefined &&
                          UserData.first_name != undefined ? (
                            <p class="text-muted lead mb-0">
                              {UserData.first_name}
                            </p>
                          ) : null}
                        </div>
                        <div className="col-md-6" style={{ textAlign: "end" }}>
                          <h6>Role :</h6>
                        </div>
                        <div
                          className="col-md-6"
                          style={{ textAlign: "center" }}
                        >
                          {RoleBased != undefined ? (
                            <p class="text-muted lead mb-0">
                              {capitalizeFirstLetter(RoleBased)}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      {/* <h6>{UserData.first_name}</h6> */}
                    </div>
                  </div>
                  {/* <a class="dropdown-item" href="#">My Profile</a>
                                    <a class="dropdown-item" href="#">Settings</a> */}
                  <div className="BtnPart">
                    <button
                      class="dropdown-item ButtonCSS"
                      href="#"
                      onClick={handleLOgout}
                    >
                      Logout
                    </button>
                    <button
                      class="dropdown-item ButtonCSS" 
                       style={{marginLeft:"12px" , display:"flex", justifyContent:"center", textAlign:"center"}}
                      href="#"
                      onClick={(e)=>{
                        dispatch(SetActiveTabs(1));

                        navigate("/userprofilepart")
                      }}
                    >
                      View
                    </button>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
